import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { confirmAlert } from "react-confirm-alert";
import { removeByCodigo } from "./api-sala-mensagem";
import { errorToast, success } from "../../../util/ToastUtil";

const SMMenuOptions = ({ listSMSelect, setListSMSelect, setSalaMensagens }) => {
  if (listSMSelect.length === 0) return null;

  const deleteMessages = () => {
    Promise.all(
      listSMSelect.map((sm) => removeByCodigo(sm.codigo).then((data) => ({ sm, ok: data && !data.error }))),
    ).then((results) => {
      const removidas = new Set(results.filter((r) => r.ok).map((r) => r.sm.codigo));
      const falhas = results.length - removidas.size;
      setSalaMensagens((prevState) => ({
        ...prevState,
        content: prevState.content.filter((sm) => !removidas.has(sm.codigo)),
      }));
      if (removidas.size > 0) success(`${removidas.size} mensagem(ns) excluída(s).`);
      if (falhas > 0) errorToast(`Não foi possível excluir ${falhas} mensagem(ns).`);
      setListSMSelect([]);
    });
  };

  const handleDeleteMessages = () => {
    confirmAlert({
      title: "Alerta",
      message: `Deseja excluir ${listSMSelect.length} mensagem(ns) selecionada(s)?`,
      buttons: [
        { label: "Sim", onClick: deleteMessages },
        { label: "Não", onClick: () => {} },
      ],
    });
  };

  return (
    <Paper
      variant="outlined"
      sx={{ px: 2, py: 1, mb: 1, borderRadius: 2, borderColor: "warning.main" }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="body2" flexGrow={1}>
          {listSMSelect.length} mensagem(ns) selecionada(s)
        </Typography>
        <Button size="small" color="inherit" onClick={() => setListSMSelect([])}>
          Cancelar
        </Button>
        <Button
          size="small"
          color="error"
          variant="contained"
          startIcon={<DeleteOutlineIcon />}
          onClick={handleDeleteMessages}
        >
          Excluir
        </Button>
      </Stack>
    </Paper>
  );
};

export default SMMenuOptions;
